// src/services/redux/api/components/lifeInsurance/policyReportService.js
import {
  useGetPolicyReportQuery,
  usePreviewPolicyReportQuery,
  useExportPolicyReportMutation,
  useGetExportStatusQuery,
  useDownloadExportQuery,
} from '../../baseApi';

// 1) List hook (paginated / filtered)
// Usage: const { data, isLoading, error } = usePolicyReportList(1, 1000, { fromDate, toDate })
export const usePolicyReportList = (pageNumber = 1, pageSize = 10, filters = {}, options = {}) => {
  const payload = { pageNumber, pageSize, ...filters };
  return useGetPolicyReportQuery(payload, options);
};

// preview wrapper
// Usage: const { data, isLoading, error } = usePreviewPolicyReport({ fromDate, toDate, includeAddress: true })
export const usePreviewPolicyReport = (params = {}, options = {}) => {
  return usePreviewPolicyReportQuery(params, options);
};

// 2) Create export job (mutation)
// Usage: const [createExportJob, { isLoading, data, error }] = useCreateExportJob();
export const useCreateExportJob = () => {
  return useExportPolicyReportMutation();
};

// 3) Export job status (query wrapper)
// Usage: const { data: job, isFetching } = useExportJobStatus(jobId, { pollingInterval: 2000 });
export const useExportJobStatus = (jobId, options = {}) => {
  // delegate to RTK Query hook
  return useGetExportStatusQuery(jobId, options);
};

// 4) Convenience operations object (combined)
export const usePolicyReportOperations = () => {
  const [createExportJob, { isLoading: creatingJob, data: exportResult, error: exportError }] =
    useExportPolicyReportMutation();

  return {
    createExportJob,
    creatingJob,
    exportResult,
    exportError,
    useExportJobStatus, // consumer can call useExportJobStatus(jobId, opts)
    usePreviewPolicyReport, // convenience: consumer can call preview wrapper
  };
};

// 5) Convenience wrapper for download (returns blob response)
// Usage: const { data: blob, isFetching } = useDownloadExport(jobId);
export const useDownloadExport = (jobId, options = {}) => {
  return useDownloadExportQuery(jobId, options);
};
